import { fetchApi } from '@/config/axiosSetting';
import { PatchAccessoryInitialVisitQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAccessoryInitialVisit/patchAccessoryInitialVisitQuery.type';

export const patchAccessoryInitialVisitFunction = (
  params: PatchAccessoryInitialVisitQueryParamsType,
) => {
  return fetchApi.patch(
    `/initial/reports/${params?.id}/accessory/`,
    params?.data,
    {
      params: {
        part_id: params?.part_id,
      },
    },
  );
};
